import { render, staticRenderFns } from "./LicenseActivationModal.vue?vue&type=template&id=36f9619c&scoped=true"
import script from "./LicenseActivationModal.vue?vue&type=script&lang=js"
export * from "./LicenseActivationModal.vue?vue&type=script&lang=js"
import style0 from "./LicenseActivationModal.vue?vue&type=style&index=0&id=36f9619c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f9619c",
  null
  
)

export default component.exports